import script from "./RuntimePopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./RuntimePopover.vue?vue&type=script&setup=true&lang=ts"

import "./RuntimePopover.vue?vue&type=style&index=0&id=4681e949&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4681e949"]])

export default __exports__